
import FooterContent from './footer/FooterContent.vue';
import FooterIcons from './footer/FooterIcons.vue';
export default {
  components: {
    FooterContent,
    FooterIcons
  },
  methods: {
    yourChoiceLink() {
      return this.$i18n.locale === 'id' ? '/id/data-sharing' : this.$i18n.locale === 'es' ? '/es/data-sharing' : '/data-sharing'
    }
  },
}
